module.exports = __webpack_public_path__ + "static/img/logo-pecos-half.02334d63.png";